import api from "../axios/axios-config";

export const getPackages = async () => {
  try {
    let response = await api.get(
      "package/listOfPackages",

      
    );
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const addPackage = async (data) => {
  try {
    let response = await api.post("package/createPackage", data);
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const updatePackage = async (dataId, data) => {
  try {
    let response = await api.post(
      "package/updatePackage",
      {
        dataId,
        ...data,
      },
      
    );
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};
